module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orders
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "商品信息",
      "width": "420"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('div', {
            staticClass: "order-title"
          }, [_c('div', [_c('span', {
            staticStyle: {
              "font-weight": "bold"
            }
          }, [_vm._v(_vm._s(_vm.getLocalTime(_vm.row.createTime)))]), _vm._v("\n              订单号：" + _vm._s(_vm.row.orderCode) + "\n          ")])]), _vm._v(" "), _vm._l((_vm.row.details), function(item) {
            return _c('el-row', {
              staticStyle: {
                "height": "90px"
              }
            }, [_c('el-col', {
              staticClass: "order-detail",
              attrs: {
                "span": 5
              }
            }, [_c('div', {
              staticStyle: {
                "width": "100%",
                "height": "100%",
                "display": "table-cell",
                "vertical-align": "middle"
              }
            }, [_c('img', {
              staticStyle: {
                "width": "100%",
                "display": "table-cell",
                "vertical-align": "middle"
              },
              attrs: {
                "src": _vm.productCover(item.productSerialId)
              },
              on: {
                "~error": function($event) {
                  _vm.productCoverInError($event)
                }
              }
            })])]), _vm._v(" "), _c('el-col', {
              staticClass: "order-detail",
              attrs: {
                "span": 19
              }
            }, [_c('div', {
              staticClass: "order-detail-wrapper"
            }, [_c('p', {
              staticClass: "order-detail-product-title"
            }, [_c('router-link', {
              attrs: {
                "to": {
                  name: 'product-detail',
                  params: {
                    serialId: item.productSerialId
                  }
                }
              }
            }, [_vm._v(_vm._s(item.name))])], 1), _vm._v(" "), _c('p', {
              staticClass: "order-detail-product-region"
            }, [_vm._v("\n                区域：" + _vm._s(item.region) + "\n              ")])])])], 1)
          })], 2)
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "amount",
      "label": "数量"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('div', {
            staticClass: "top-splitter"
          }), _vm._v(" "), _vm._l((_vm.row.details), function(item) {
            return _c('el-row', {
              staticStyle: {
                "height": "90px",
                "padding-top": "42px"
              }
            }, [_c('el-col', {
              staticClass: "order-detail",
              attrs: {
                "span": 24
              }
            }, [_c('div', {
              staticClass: "order-detail-wrapper",
              staticStyle: {
                "padding-left": "0"
              }
            }, [_c('p', {
              staticClass: "order-detail-product-title"
            }, [_c('b', [_vm._v(_vm._s(item.amount))]), _vm._v(" " + _vm._s(item.unit) + "\n              ")])])])], 1)
          })], 2)
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "totalPrice",
      "label": "金额"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticStyle: {
              "color": "red",
              "padding-top": "42px"
            }
          }, [_c('div', {
            staticClass: "top-splitter"
          }), _vm._v("\n        ¥\n        "), _c('span', [_vm._v(_vm._s(_vm.row.totalPrice.toFixed(2)))]), _vm._v(" "), (_vm.giftPrice(_vm.row.details) !== 0) ? _c('span', [_c('br'), _vm._v("赠 " + _vm._s(_vm.giftPrice(_vm.row.details)))]) : _vm._e()])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "交易状态"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticStyle: {
              "padding-top": "42px"
            }
          }, [_c('div', {
            staticClass: "top-splitter"
          }), _vm._v("\n        " + _vm._s(_vm.orderStage(_vm.row.orderStage)) + "\n      ")])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('div', {
            staticClass: "top-splitter"
          }, [(_vm.row.orderStage !== 'UNPAID') ? _c('a', {
            on: {
              "click": function($event) {
                _vm.deleteOrder(_vm.$index, _vm.row.orderCode)
              }
            }
          }, [_c('img', {
            staticStyle: {
              "margin-top": "10px",
              "cursor": "pointer"
            },
            attrs: {
              "alt": "删除icon",
              "src": "//v3.cdn.qiyewan.com/delete.png"
            }
          })]) : _vm._e()]), _vm._v(" "), (_vm.row.orderStage === 'UNPAID') ? _c('div', {
            staticStyle: {
              "padding-top": "42px"
            }
          }, [_c('el-button', {
            attrs: {
              "type": "primary",
              "size": "small"
            },
            nativeOn: {
              "click": function($event) {
                _vm.jumpToPay(_vm.row)
              }
            }
          }, [_vm._v("去付款")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text"
            },
            nativeOn: {
              "click": function($event) {
                _vm.cancelOrder(_vm.$index, _vm.row.orderCode)
              }
            }
          }, [_vm._v("取消订单")])], 1) : _vm._e(), _vm._v(" "), (_vm.row.orderStage === 'PAID') ? _c('div', [_c('el-row', {
            staticStyle: {
              "height": "90px",
              "padding-top": "42px"
            }
          }, [_c('el-col', {
            staticClass: "order-detail",
            attrs: {
              "span": 24
            }
          }, [_c('div', {
            staticClass: "order-detail-wrapper",
            staticStyle: {
              "padding-left": "0"
            }
          }, [_c('p', {
            staticClass: "order-detail-product-title"
          }, [_c('el-button', {
            attrs: {
              "type": "primary",
              "icon": "edit",
              "size": "small"
            },
            nativeOn: {
              "click": function($event) {
                _vm.goToReview(_vm.row, _vm.item)
              }
            }
          }, [_vm._v("去评价\n                  ")])], 1)])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.row.orderStage === 'REVIEWED') ? _c('div', _vm._l((_vm.row.details), function(item) {
            return _c('el-row', {
              staticStyle: {
                "height": "90px",
                "padding-top": "42px"
              }
            }, [_c('el-col', {
              staticClass: "order-detail",
              attrs: {
                "span": 24
              }
            }, [_c('div', {
              staticClass: "order-detail-wrapper",
              staticStyle: {
                "padding-left": "0"
              }
            }, [_c('p', {
              staticClass: "order-detail-product-title"
            }, [_c('el-button', {
              attrs: {
                "type": "text",
                "disabled": true,
                "size": "small"
              }
            }, [_vm._v(" 已评价")])], 1)])])], 1)
          })) : _vm._e(), _vm._v(" "), (_vm.row.orderStage === 'TIMEOUT' || _vm.row.orderStage === 'CANCELED') ? _c('div', {
            staticStyle: {
              "padding-top": "42px"
            }
          }, [_c('el-button', {
            attrs: {
              "type": "text",
              "disabled": true,
              "size": "small"
            }
          }, [_vm._v(" 已失效")])], 1) : _vm._e()])
        
      },
      staticRenderFns: []
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-ab5489d4!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/Order.vue
// module id = 1062
// module chunks = 40